// src/components/auth/GymBrandingBanner.jsx
// Exibido no topo da tela de login/cadastro quando o usuário
// chegou via link de academia (QR code ou referral link).

import React from 'react';
import LESVITA_LOGO from '../../Assets/images/logo/iconeApp1024.webp';
import useGymBranding from '../../hooks/useGymBranding';
import Style from '../../styles/components/auth/GymBrandingBanner.module.css';

export default function GymBrandingBanner() {
  const gym = useGymBranding();

  // Só exibe se veio de uma academia
  if (!gym?.gymCode) return null;

  return (
    <div className={Style.banner}>
      {/* Logo da academia */}
      <div className={Style.logoWrap}>
        {gym.logoUrl ? (
          <img
            src={gym.logoUrl}
            alt={`Logo ${gym.gymName || 'Academia'}`}
            className={Style.gymLogo}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
        ) : (
          <div className={Style.gymLogoFallback}>
            {gym.gymName?.[0]?.toUpperCase() || '🏋️'}
          </div>
        )}
      </div>

      {/* Separador */}
      <span className={Style.plus}>+</span>

      {/* Logo LesVita */}
      <div className={Style.logoWrap}>
        <img
          src={LESVITA_LOGO}
          alt="LesVita"
          className={Style.lesvitaLogo}
        />
      </div>

      {/* Nome da academia */}
      {gym.gymName && (
        <p className={Style.gymName}>
          Acesso via <strong>{gym.gymName}</strong>
          {gym.city ? ` — ${gym.city}${gym.stateUf ? `/${gym.stateUf}` : ''}` : ''}
        </p>
      )}
    </div>
  );
}